import React from 'react';
import { Loading } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import { useMatchRoute } from '@tanstack/react-router';
import { useGetStatuses } from '@views/Settings/TicketStatuses/hooks';
import { APP_PATHS } from '../types';
import { useAvContext } from './AvContextProvider';

export const RouteLoadingContext = React.createContext(null);

const APPS_LIST = [APP_PATHS.VULNERABILITIES, APP_PATHS.DETECTIONS, APP_PATHS.INCIDENTS, APP_PATHS.RISK360, APP_PATHS.ASSETS];

export default function RouteLoadingProvider({ children }: React.PropsWithChildren<{}>) {
  const { isLoading: isLoadingStatuses } = useGetStatuses();
  const { isLoading, user, selectedApp } = useAvContext();
  const matchRoute = useMatchRoute();
  const isHome = matchRoute({ to: '/$accountId' });

  if (
    (!isHome && APPS_LIST.includes(selectedApp) && isLoadingStatuses) ||
    isLoading ||
    (!user.roleId && !user.roleName) ||
    (!isHome && (!selectedApp || selectedApp === ''))
  ) {
    return (
      <Box sx={{ ...flex.center, height: '100%' }}>
        <Loading />
      </Box>
    );
  }

  return <RouteLoadingContext.Provider value={null}>{children}</RouteLoadingContext.Provider>;
}
